import { render, staticRenderFns } from "./scroll-pane.vue?vue&type=template&id=07be2996"
import script from "./scroll-pane.vue?vue&type=script&lang=js"
export * from "./scroll-pane.vue?vue&type=script&lang=js"
import style0 from "./scroll-pane.vue?vue&type=style&index=0&id=07be2996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports